import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import Divider from '@mui/material/Divider'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import {InfoItem} from '../../components/text'
import {NavButton} from '../../components/forms/inputs'
import type {Alert as AlertType} from '../../services/types'
import Subscribe from './Subscribe'
import {StatusIcons} from './widgets'
import Path from '../../routeLinks'

const Alert = ({alert}: {alert: AlertType}) => {
  return (
    <Card sx={{borderRadius: 3}}>
      <CardContent>
        <Stack direction={{xs: 'column', sm: 'row'}} justifyContent="space-between" spacing={2}>
          <StatusIcons alert={alert} />
          <CardContent sx={{flex: 1}}>
            <Stack spacing={2} justifyContent="space-between" alignItems="flex-start">
              <Typography variant="h5">{alert.name}</Typography>
              <InfoItem title="Details" value={alert.description} variant="inherit" markdown />
            </Stack>
          </CardContent>

          <CardContent sx={{minWidth: 170}}>
            <Stack direction="column" justifyContent="space-between" spacing={2}>
              <Typography variant="h5"> </Typography> {/* This is to keep the padding equal*/}
              <InfoItem
                title="Alert creator"
                value={alert?.owner?.full_name || alert?.owner?.user_name}
                to={alert?.owner?.id && Path.user.profile(alert?.owner?.id)}
                variant="inherit"
              />
            </Stack>
          </CardContent>

          <Divider orientation="vertical" flexItem />

          <Stack
            spacing={5}
            direction="column"
            justifyContent="center"
            alignItems="center"
            sx={{minWidth: 150}}
          >
            <NavButton to={Path.alerts.show(alert.id)} label="Learn more" />
            <Subscribe alert={alert} />
            <NavButton to="mailto:alerts@equistamp.com" label="Contact us" />
          </Stack>
        </Stack>
      </CardContent>
    </Card>
  )
}

export default Alert
